import React from "react"
import SearchBox from "@digits-shared/components/UI/Elements/SearchBox"
import colors from "@digits-shared/themes/colors"
import styled from "styled-components"

const StyledSearchBox = styled(SearchBox)`
  flex: 1;
  padding: 0;
  border: none;

  input {
    padding: 0;

    &::placeholder {
      color: ${colors.secondary50};
      text-transform: unset;
    }
  }
`

interface TextFilterInputProps {
  filterTerm: string
  setFilterTerm: (term: string) => void
  placeholder?: string
}

export const TextFilterInput: React.FC<TextFilterInputProps> = ({
  filterTerm,
  setFilterTerm,
  placeholder = "Filter…",
}) => (
  <StyledSearchBox
    hideIcon
    noClear
    initialValue={filterTerm}
    onChange={setFilterTerm}
    shouldDebounceOnChange
    placeholder={placeholder}
  />
)
